var Acr = Acr || {};

Acr.StayInformedForm = function () {
  var $element;
  var $input;
  var $form;
  var $processing;
  var $body;
  var $response;
  var $copy;
  var $messages;
  var $submitButton;
  var $contactDealerCheck;
  var $zipInput;
  const processingClass = '.acr-stay-informed__processing';
  const bodyClass = '.acr-stay-informed__body';
  const copyClass = '.acr-stay-informed__copy';
  const responseClass = '.acr-stay-informed__response';
  const messagesClass = '.acr-stay-informed__messages';
  const showFormBtn = '.js-show-form';
  const submBtn = '.acr-stay-informed__btn';
  const contactDealerCheck = '.acr-stay-informed__contact-dealer-checkbox';
  const zipInput = '.acr-stay-informed__input[name="ZipCode"]';
  const requiredClass = 'acr-required';
  const requiredAttr = 'required';
  const errorTextClass = '.acr-stay-informed__error';
  const errorStateClass = 'acr-form-element-error';

  function showForm() {
    $messages.hide();
    $body.show();
    $form.reset();
  }

  var sendSuccessTrackingObject = function (isSuccess) {
    var stringObject = $submitButton.attr('data-form-submit-tracking')
      ? $submitButton.attr('data-form-submit-tracking')
      : '';
    if (Acr.TrackingManager && stringObject) {
      try {
        var object = JSON.parse(stringObject.split("'").join('"'));
        if (isSuccess && object) {
          object.dynamic_variables[0].search += ' success';
        }
        Acr.TrackingManager.clickActivity(object);
      } catch (err) {
        console.warn('ERROR AT TRACKING OBJECT: ' + err);
      }
    }
  };

  function send(form) {
    var data;
    var method;
    var action;

    data = Acr.CampaignManager.appendCampaignName($(form).serialize());
    method = form.getAttribute('method');
    action = form.getAttribute('action');
    $.ajax({
      beforeSend: function () {
        $processing.show();
        $body.hide();
      },
      data: data,
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
      },
      method: method,
      success: function (data) {
        var message;
        if (data.Status === 'success') {
          sendSuccessTrackingObject(true);
        }
        message = $('<div>').html(data.Message).text();
        $processing.hide();
        $copy.html(message);
        $response.show();
        if ($response.length !== 0) {
          $response[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      },
      url: action,
    });
  }

  function onSubmit(e) {
    var success = Validation.validateForm(e);
    Utility.log('onSubmit submission', e);

    if (success) {
      sendSuccessTrackingObject(false);
      send(e.target);
    }

    e.preventDefault();
    return false;
  }

  function toogleZipCodeRequired(e) {
    var checkbox = e.target;

    if (checkbox.checked && $zipInput && !$zipInput.hasClass(requiredClass)) {
      $zipInput.addClass(requiredClass);
      $zipInput.attr(requiredAttr, requiredAttr);
    } else if ($zipInput) {
      $zipInput.removeClass(requiredClass);
      $zipInput.removeAttr(requiredAttr);
      $zipInput.siblings(errorTextClass).html('');
      $zipInput.parent().removeClass(errorStateClass);
    }
  }

  function initSelectors(element) {
    $element = $(element);
    $input = $element.find('input');
    $form = $element.find('form');
    $processing = $element.find(processingClass);
    $body = $element.find(bodyClass);
    $copy = $element.find(copyClass);
    $response = $element.find(responseClass);
    $messages = $element.find(messagesClass);
    $submitButton = $(element).find(submBtn);
    $contactDealerCheck = $(element).find(contactDealerCheck);
    $zipInput = $(element).find(zipInput);
  }

  function bindEvents(element) {
    initSelectors(element);

    $($input, $form)
      .on('keypress', Validation.onKeypress)
      .on('keyup', Validation.onKeyup)
      .on('focus', Validation.onFocus)
      .on('blur', Validation.onBlur);

    $form.on('submit', onSubmit);

    $contactDealerCheck.change(toogleZipCodeRequired);
  }

  function init(element) {
    bindEvents(element);
  }

  return {
    init: init,
  };
};
